<div class="empty-state">
    <i class="fa" [ngClass]="icon"></i>
    <div class="text">{{ text }}</div>
</div>
